export const terms = {
  "header": {
    "badge": "Informacje prawne",
    "title": "Warunki użytkowania"
  },
  "content": {
    "intro": "Witamy w DONKEY TRAVEL. Niniejsze warunki użytkowania regulują dostęp i korzystanie z naszej platformy wymiany mieszkań. Korzystając z naszych usług, akceptujesz w całości niniejszy regulamin.",
    "eligibility": {
      "title": "1. Kwalifikacja i rejestracja",
      "text": "Dostęp do klubu DONKEY TRAVEL jest zarezerwowany wyłącznie dla gospodarzy posiadających aktywną reklamę na uznanych platformach (takich jak Airbnb) z minimalną oceną ogólną 4,5 z 5. Każde fałszowanie tych kryteriów będzie skutkować natychmiastowym usunięciem konta bez zwrotu kosztów abonamentu."
    },
    "subscription": {
      "title": "2. Subskrypcja i płatności",
      "text": "Pełne korzystanie z platformy wymaga wykupienia jednego z naszych pakietów (Miesięcznego, Rocznego lub Klub+). Płatności są bezpieczne i przetwarzane przez zewnętrznych dostawców. Subskrypcja jest automatycznie odnawialna, chyba że użytkownik ją anuluje."
    },
    "exchanges": {
      "title": "3. Jak działają giełdy",
      "text": "Wymiana wewnątrz klubu opiera się na zaufaniu i wzajemnym szacunku. Umowy o wymianę są zawierane bezpośrednio pomiędzy członkami za pośrednictwem naszego wewnętrznego komunikatora. Między obiema stronami zostaje zawarta moralna i, w stosownych przypadkach, prawna umowa wymiany."
    },
    "responsibilities": {
      "title": "4. Zobowiązania i obowiązki",
      "text": "Każdy członek zobowiązuje się do przedstawienia swojego zakwaterowania w sposób przejrzysty, z aktualnymi zdjęciami i dokładnymi opisami. Gospodarz dba o nienaganną higienę miejsca. Członek odwiedzający zobowiązuje się do skrupulatnego przestrzegania obiektu zakwaterowania i jego wewnętrznych przepisów. DONKEY TRAVEL pełni rolę koordynatora i nie jest stroną umów wymiany pomiędzy członkami. Nie ponosimy odpowiedzialności za szkody, spory lub anulowanie rezerwacji w ostatniej chwili, chociaż możemy interweniować w drodze mediacji."
    },
    "termination": {
      "title": "5. Zawieszenie i zakończenie",
      "text": "DONKEY TRAVEL zastrzega sobie prawo do zawieszenia lub zablokowania każdego członka, który nie przestrzega zasad dobrego postępowania w społeczności, gromadzi złe opinie lub jednostronnie narusza niniejsze warunki."
    },
    "contact": {
      "title": "6. Obowiązujące prawo i spory",
      "text": "Warunki te podlegają prawu francuskiemu. W przypadku braku porozumienia strony zobowiązują się do poszukiwania polubownego rozwiązania przed podjęciem jakichkolwiek działań prawnych przed właściwymi sądami. W przypadku jakichkolwiek pytań prosimy o kontakt pod adresem legal@donkey.travel."
    }
  }
};
